// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m3Bay","fullView":"styles_fullView__1Dpic"};